export default {
  'directSale.columns.table.tag': 'Tag',
  'directSale.columns.table.company': 'Company',
  'directSale.columns.table.code': 'Code',
  'directSale.columns.table.customer': 'Customer',
  'directSale.columns.table.status': 'Situation',
  'directSale.columns.table.dateOfSale': 'Date of Sale',
  'directSale.columns.table.saleValue': 'Sale Value',

  'directSale.situation': 'Situation: ',
  'directSale.OPEN': 'Open',
  'directSale.AUTHORIZED': 'Authorized',
  'directSale.CANCELED': 'Canceled',

  'directSale.create': 'New Sale',
  'directSale.form.company': 'Company',
  'directSale.form.saller': 'Salesman',
  'directSale.form.customer': 'Customer',
  'directSale.form.dateOfSale': 'Date of Sale',
  'directSale.form.details.saleCode': 'Sale Code',
  'directSale.form.details.authorizationDate': 'Authorization Date',
  'directSale.form.details.cancellationDate': 'Cancellation Date',
  'directSale.form.details.reasonCancellation': 'Reason Cancellation',
  'directSale.form.observation': 'Observation',

  'directSale.modal.title': 'Sale Items',
  'directSale.modal.form.manufacturerCode': 'Manufac. Code',
  'directSale.modal.form.internalCode': 'Internal Code',
  'directSale.modal.form.barCode': 'Bar Code',
  'directSale.modal.form.companyCode': 'Company Code',
  'directSale.modal.form.description': 'Description',
  'directSale.modal.form.manufacturer': 'Manufacturer',
  'directSale.modal.form.qty': 'Qty.',
  'directSale.modal.form.unitaryValue': '(US$) Unitary Value',
  'directSale.modal.form.discount': '(%) Discount',
  'directSale.modal.form.discountCost': '(US$) Discount ',
  'directSale.modal.form.amount': 'Amount ',
  'directSale.modal.form.open.emptyCompanyAndCustomerError': 'Error',
  'directSale.modal.form.open.emptyCompanyAndCustomerDescription':
    'Please select a Company and a Customer to add a part!',

  'directSale.transmitModal.title': 'Access invoice',
  'directSale.transmitModal.description':
    'Select the payment method(s) to transmit the Invoice.',
  'directSale.transmitModal.description.invoiceNumber':
    'Invoice number: {number}',
  'directSale.transmitModal.table.paymentType': 'Type of payment',
  'directSale.transmitModal.table.value': 'Value',
  'directSale.transmitModal.table.authorizationNumber': 'Authorization number',
  'directSale.transmitModal.button.addPayment': 'Add Payment',
  'directSale.transmitModal.button.transmitInvoice': 'Transmit invoice',

  'directSale.transmitModal.paymentForm.integrationType': 'Type of integration',
  'directSale.transmitModal.paymentForm.legalCredentialCard':
    'CNPJ accrediting card',
  'directSale.transmitModal.paymentForm.cardFlag': 'Card flag',

  'directSale.transmitModal.paymentForm.integrationOptions.integrated':
    "Payment integrated with the company's automation system (Ex: TEF equipment, Electronic Commerce)",
  'directSale.transmitModal.paymentForm.integrationOptions.noIntegrated':
    "Payment not integrated with the company's automation system (Ex: POS equipment)",

  'directSale.transmitModal.paymentForm.paymentTypeOptions.money': 'Money',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.check': 'Check',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.creditCard':
    'Credit Card',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.debitCard':
    'Debit Card',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.storeCredit':
    'Store Credit',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.foodVoucher':
    'Food Voucher',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.mealTicket':
    'Meal Ticket',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.giftVoucher':
    'Gift Voucher',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.fuelVoucher':
    'Fuel Voucher',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.mercantileDuplicate':
    'Mercantile Duplicate',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.bankSlip':
    'Bank Slip',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.bankDeposit':
    'Bank Deposit',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.instantPayment':
    'Instant Payment (PIX)',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.bankTransfer':
    'Bank Transfer',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.loyaltyProgram':
    'Loyalty Program',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.withoutPay':
    'Without Pay',

  'directSale.form.domain.items.parts': 'Parts',
  'directSale.form.domain.button.addPart': 'Add Part',
  'directSale.form.domain.items.manufacturerCode': 'Cod. Manufacturer',
  'directSale.form.domain.items.description': 'Description',
  'directSale.form.domain.items.amount': 'Qty.',
  'directSale.form.domain.items.unitaryValue': 'Unitary value',
  'directSale.form.domain.items.discount': 'Discount (%)',
  'directSale.form.domain.items.discountCost': 'Discount (US$)',
  'directSale.form.domain.items.totalValue': 'Total Value',

  'directSale.financial.form.planAccount': 'Plan Account',
  'directSale.financial.form.documentType': 'Document Type',
  'directSale.financial.form.paymentCondition': 'Payment Condition',
  'directSale.financial.form.valueNegotiated': 'Value To Be Negotiated',
  'directSale.financial.button.negotiateFinancial': 'Negotiate Financial',
  'directSale.financial.table.generateFinancial': 'Generate Financial',
  'directSale.financial.table.generateOrder': 'Generate Order',
  'directSale.financial.table.description': 'Description',
  'directSale.financial.table.documentNumber': 'Nº Document',
  'directSale.financial.table.documentType': 'Document Type',
  'directSale.financial.table.dueDate': 'Due Date',
  'directSale.financial.table.value': 'Value',
  'directSale.financial.table.increaseAndDecrease': 'Incre./Decre.',
  'directSale.financial.table.tariff': 'Tariff',
  'directSale.financial.table.realValue': 'Real Value',

  'directSale.create.notification.success': 'Direct Sale Created!',
  'directSale.create.notification.successDescription':
    'Direct Selling has been correctly added to the system!',
  'directSale.notifications.remove.confirm.title':
    'Do you really want to delete this Direct Sale?',
  'directSale.notifications.remove.confirm.content':
    'By removing Direct Selling, all information will be permanently lost. Do you still want to continue?',
  'directSale.notifications.remove.success.title': 'Direct sale removed!',
  'directSale.notifications.remove.success.description':
    'Direct Selling has been successfully removed!',
  'directSale.notifications.update.success.title':
    'Direct Sale successfully updated!',
  'directSale.notifications.update.success.description':
    'The Direct Sale information has been updated successfully.',

  'directSale.notification.create.item.success.title': 'Sucess!',
  'directSale.notification.create.item.success.description':
    'Item created successfully!',
  'directSale.notification.update.item.success.title': 'Success!',
  'directSale.notification.update.item.success.description':
    'Item successfully changed!',
  'directSale.notifications.remove.item.confirm.title':
    'Do you really want to delete the Item?',
  'directSale.notifications.remove.item.confirm.content':
    'When removing the Sale Item, its recovery cannot be done. Do you still want to continue?',
  'directSale.notification.remove.item.success.title': 'Success!',
  'directSale.notification.remove.item.success.description':
    'Item successfully removed!',
  'directSale.notification.update.item.success.description':
    'Item successfully changed!',

  'directSale.create.items.searchMessage':
    'Filter and select the items to be added in the Direct Sale.',

  'directSale.button.authorizeSale': 'Authorize Sale',
  'directSale.notifications.authorizeSale.confirm.title':
    'Do you really want to authorize the sale?',
  'directSale.notifications.authorizeSale.confirm.content':
    'When authorizing the Direct Sale, there is no way to reverse the authorization. Do you still want to continue?',
  'directSale.notifications.authorizeSale.success.title': 'Success!',
  'directSale.notifications.authorizeSale.success.description':
    'Your sale has been successfully authorized!',

  'directSale.button.cancelSale': 'Cancel Sale',
  'directSale.cancelSale.modal.title.reasonCancellation':
    'Reason for cancellation',
  'directSale.notifications.cancelSale.success.title': 'Success!',
  'directSale.notifications.cancelSale.success.description':
    'Sale canceled successfully!',

  'directSale.button.generateInvoice': 'Generate Invoice',
  'directSale.generateInvoice.modal.title.modelInvoice': 'Model Invoice',
  'directSale.generateInvoice.modal.title.modelInvoiceNfe': 'NF-e model 55',
  'directSale.generateInvoice.modal.title.modelInvoiceNfce': 'NFC-e model 65',
  'directSale.generateInvoice.modal.create': 'Create Invoice only',
  'directSale.generateInvoice.modal.createRedirect':
    'Create and Redirect to Invoice',

  'directSale.generateInvoice.notification.success': 'Success!',
  'directSale.generateInvoice.notification.successDescription':
    'Invoice was successfully generated by Direct Sale!',

  'directSale.button.printSale': 'Print Sale',
  'directSale.button.termLgbt': 'Term LGPD',
};
